import ProgressIndicator from '@/components/ProgressIndicator';
import PlusCircle from '@/components/Icons/PlusCircle';
import s from '../IconButton.module.scss';
import type { Interface } from '../typings';

const AddButton: React.FC<Interface> = ({ disabled, loading, onClick }) => {
  if (loading) {
    return (
      <ProgressIndicator size={20}/>
    );
  }
  return (
    <button
      className={s.wrapper}
      disabled={disabled}
      onClick={onClick}
    >
      <PlusCircle weight="fill" size={20} color="var(--color-primary)" />
    </button>

  );
};

export default AddButton;